import React , { ChangeEvent, FunctionComponent, useEffect, useRef, useState } from "react";
import { Autocomplete, CircularProgress, createFilterOptions, Dialog, TextField } from "@mui/material";
import images from "../../../assets/images";
import { useDropzone } from "react-dropzone";
import { Card, CardCover } from "@mui/joy";
import { useLazyQuery, useMutation } from "@apollo/client";
import "./../FileUpload.scss";
import ToasterWithMessage from "../../toaster";
import axios from "axios";
import moment from "moment";
import { CLASSROOM_S3_PATH, FETCH_POLICY, FILE_NAME_ALREADY_EXISTS_TEXT, FONT_SIZE_XS, IMAGE_MATERIAL_TEXT, INTER_FONT_FAMILY, MATERIALS_TEXT, MYLIBRARY_TEXTS, PATH_ADDRESSES, PODCAST_MATERIAL_TEXT, QUESTION_BANK_TEXT, SCHOOL_ADMIN, STUDENT_ROLE, SUBJECT_NOT_FOUND_ERROR, SUBJECT_NOT_FOUND__FOR_TEACHER_ERROR, TEACHER_ROLE, VIDEO_CATEGORY_REQUIRED_TEXT, messages, patterns } from "../../../utils/constants";
import { CHECK_UNIQUE_NAME_EXIST_IN_WORKSHOP, GET_PRESIGNED_URL } from "./../api/FileUploadQuery";
import { useAppSelector } from "../../../redux/app/hooks";
import { VIEW_ALL_LIBRARY_IMAGES, VIEW_ALL_LIBRARY_IMAGES_ADMIN } from "../../../pages/ImageMaterial/api/ImageMaterialQuery";
import { VIEW_ALL_EBOOK_MATERIAL, VIEW_ALL_MATERIAL_ADMIN } from "../../../pages/TeacherTeachingMaterial/api/TeacherTeachingMaterialQuery";
import { useNavigate } from "react-router-dom";
import { ADD_CATEGORY, GET_ALL_SYNDICATED_VIDEOS, GET_ALL_SYNDICATED_VIDEOS_ADMIN, GET_CATEGORY, GET_OR_CREATE_BULKUPLOAD_CATEGORY } from "../../../pages/SyndicatedVideos/api/SyndicatedVideosQuery";
import { GET_ALL_SUBMITTED_ASSIGNMENTS, GET_ASSIGNMENTS } from "../../../pages/Assignments/api/AssignmentsQuery";
import { isPlatform } from "@ionic/react";
import { getFilePreview, getMaxBatchSize, getScreenDimensions } from "../../../utils/helper";
import { useWindowWidth } from "../../AdminDashboardTabsContentHeader/TabsContentHeader";
import { VIEW_ALL_LIBRARY_PODCAST_ADMIN } from "../../../pages/PodCast/api/PodCastQueries";
import { UploadedFilePayload, VideosListForCategory } from "../../../pages/SyndicatedVideos/SyndicatedVideos";
import { trackButtonClick } from "../../../firebase/analyticsHelper";
import { ButtonClickEvents } from "../../../firebase/constants/events";
import { materialsData } from "../../../utils/interface";
import { GuidesData } from "../../../pages/TeacherExaminationGuides/TeacherExaminationGuides";
import { getFileType } from "../../../pages/AdminBulkUpload/components/Helper";

export type FileTypes = {
  all: 'all';
  pdf: 'pdf';
  image: 'image';
  video: 'video';
  audio: 'audio';
  assignment: 'assignment';
  profile: 'profile';
  questionsBank: 'questionsBank';
  teachingMaterials: 'teachingMaterials';
};

export type FileUploadType = {
  type: FileTypes[keyof FileTypes];
  isEdit?: boolean;
  selectedFileData?: VideosListForCategory | materialsData | GuidesData | undefined;
  setIsEdit?: (val: boolean) => void;
  setUrl: (val: string) => void;
  setCoverImageUrl?: (val: string) => void;
  coverImageUrl?: string;
  setVideoFileData?: (val: VideosListForCategory | undefined) => void;
  setMaterialAction?: (val: any) => void;
  setHasSubmittedForEdit?: (val: boolean) => void;
  open: boolean;
  setOpen: any;
  setIsUploadOpen?:any;
  setFileData?: any;
  folderName: string;
  setFilename?: any;
  name?: string;
  setWorkshopDescription?: (val: string) => void;
  setPodcastDescription?: (val: string) => void;
  setGuideAuthorName?: (val: string) => void;
  setVideoCategoryData?: (val:categoryType|null|undefined) => void;
  setUploadProgress?: React.Dispatch<React.SetStateAction<number>>;
  setUploadFailed?: React.Dispatch<React.SetStateAction<boolean>>;
  setuploaded?:React.Dispatch<React.SetStateAction<boolean>>;
  setUploadFileName?:React.Dispatch<React.SetStateAction<string>>;
  // Optional callback to return all selected files (when multiple files are chosen)
  setSelectedFiles?: any;
  page: string;
  setTotalProgress?: React.Dispatch<React.SetStateAction<number>>; // to set total progress
  setSuccessCount?: React.Dispatch<React.SetStateAction<number>>; // to set success count
  setFailureCount?: React.Dispatch<React.SetStateAction<number>>; // to set failure count
  setUploadedPayloads?: React.Dispatch<React.SetStateAction<UploadedFilePayload[]>>;
  setFilesStatusData?: React.Dispatch<React.SetStateAction<BulkFileState[]>>;
};

export type categoryType = {
  inputValue?: string;
  label:string;
  id?:string;
}

export interface BulkFileState {
    file: File;
    fileName: string;
    fileType?: string | null;
    filePreview?: string;
    uploadFileName: string;
    progress: number; // 0-100
    success?: boolean | null;
    s3Key?: string | null;
    errorMessage?: string | null;
}

const CommonBulkUpload: FunctionComponent<FileUploadType> = ({ setUploadedPayloads, setFilesStatusData, setTotalProgress, setSuccessCount, setFailureCount, page, type, setHasSubmittedForEdit, isEdit, setMaterialAction, setVideoFileData, setIsEdit, coverImageUrl, selectedFileData,  name, setPodcastDescription,setGuideAuthorName, setUrl, setCoverImageUrl, open, setOpen, setFileData, folderName, setFilename, setVideoCategoryData,setUploadProgress, setUploadFailed, setuploaded, setUploadFileName, setIsUploadOpen, setWorkshopDescription, setSelectedFiles }) => {
  const { closeIcon, cloudGif, podcast, pdfImg, CoverPlusImage, csvImg, docsImg, excelPreview, powerpoint, epub } = images;
  // const [uploaded, setuploaded] = useState(false);
  const descriptionRef = useRef<HTMLTextAreaElement>(null); // Add ref for textarea
  const [coverFileName, setCoverFileName] = useState<string>('');
  const [coverImageFile, setCoverImageFile] = useState<File | null>(null);
  const [descriptionValue, setDescriptionValue] = useState<string>('');
  const [fileName, setFileName] = useState<string>("");
  const [authorNameValue, setAuthorNameValue] = useState<string>('');
  const [videoCategoryValue, setVideoCategoryValue] = useState<categoryType|null>();
  const [file, setFile] = useState<File | null>(null);
  const [fileType, setFileType] = useState<string>();
  const [filePreview, setFilePreview] = useState<string>();
  // Per-file metadata for multi-file uploads (title, description, cover, author, category, errors)
  const [selectedFilesData, setSelectedFilesData] = useState<Array<BulkFileState>>([]);
  const role = useAppSelector((state) => state.auth.role);
  const { error, success } = ToasterWithMessage();
  const [fileNameError, setFileNameError] = useState<string | null>(null);
  const [authorNameError, setAuthorNameError] = useState<string | null>(null);
  const [videoCategoryError, setVideoCategoryError] = useState<string | null>(null);
  const [descriptionError, setDescriptionError] = useState<string | null>(null);
  const [accepted, setAccepted] = useState<object>({});
  const [categories, setCategories] = useState<categoryType[]>([]);
  const [inputValue, setInputValue] = useState<string>('');
  const [hasSubmitted, setHasSubmitted] = useState<boolean>(false);
  const bucketname = process.env.REACT_APP_MEDIA_BUCKET_NAME;
  const region = process.env.REACT_APP_REGION;
  const selectedClassId = useAppSelector((state) => state?.auth?.selectedClassRoomId);
  const selectedLibraryId = localStorage.getItem('selectedLId');
  const selectedSubjectId = localStorage.getItem('selectedSId');
  const navigate = useNavigate();
  const filter = createFilterOptions<categoryType>();
  const width = useWindowWidth();
  const selectedClassroomIdAdmin = useAppSelector(
          (state) => state.CommonUpload.classroomId
        );
    // tracking counts and progress
  const [totalProgressValue, setTotalProgressValue] = useState<number>(0);
  const [successCountValue, setSuccessCountValue] = useState<number>(0);
  const [failureCountValue, setFailureCountValue] = useState<number>(0);
  const [bulkCategoryId, setBulkCategoryId] = useState<string>("");
  const profile = useAppSelector((state) => state?.auth?.adminProfile);

  const descriptionAllowedTypes = ['PodcastMaterial', 'workshopVideo'];
  const baseUrl = process.env.REACT_APP_FRONTEND_URL || '';

    // to get presignedURL
  const [getPreSignedUrl] = useLazyQuery(GET_PRESIGNED_URL, {
    fetchPolicy: FETCH_POLICY,
    onCompleted: (data) => { },
    onError: (err) => {
      // error("Something went wrong!")
    }
  });

  //API to check the unique name in image material
  const [getAllImagePodcastMaterial] = useLazyQuery(VIEW_ALL_LIBRARY_IMAGES, {
    fetchPolicy: FETCH_POLICY,
    onCompleted: (data) => { },
    onError: (err) => {
      error(err?.message);
      if (err?.message === SUBJECT_NOT_FOUND__FOR_TEACHER_ERROR || err?.message === SUBJECT_NOT_FOUND_ERROR) {
        setTimeout(() => {
          if (name === IMAGE_MATERIAL_TEXT) {
            if(role === STUDENT_ROLE){
              navigate(PATH_ADDRESSES?.STUDENT_CLASSROOM_IMAGES_PATH, { state: { title: MYLIBRARY_TEXTS?.IMAGES_TEXT } });
            }else{
               navigate(PATH_ADDRESSES?.TEACHER_CLASSROOM_IMAGES_PATH, { state: { title: MYLIBRARY_TEXTS?.IMAGES_TEXT } });
            }
          } else if (name === PODCAST_MATERIAL_TEXT) {
            if(role === STUDENT_ROLE){
              navigate(PATH_ADDRESSES?.STUDENT_CLASSROOM_PODCAST_PATH, { state: { title: MYLIBRARY_TEXTS?.PODCAST_TEXT } });
            }else{
              navigate(PATH_ADDRESSES?.TEACHER_CLASSROOM_PODCAST_PATH, { state: { title: MYLIBRARY_TEXTS?.PODCAST_TEXT } });
            }
          }
        }, 2000);
      }
    }
  });
  
  //API to check the unique name in e-books
  const [getAllTeachingMaterial] = useLazyQuery(VIEW_ALL_EBOOK_MATERIAL, {
    fetchPolicy: FETCH_POLICY,
    onCompleted: (data) => { },
    onError: (err) => {
      error(err?.message);
      if (err?.message === SUBJECT_NOT_FOUND__FOR_TEACHER_ERROR || err?.message === SUBJECT_NOT_FOUND_ERROR) {
        setTimeout(() => {
          if (role === STUDENT_ROLE) {
            navigate(PATH_ADDRESSES?.STUDENT_CLASSROOM_EBOOKS_PATH, { state: { title: 'E-Books' } });
          } else {
            navigate(PATH_ADDRESSES?.TEACHER_CLASSROOM_EBOOKS_PATH, { state: { title: 'E-Books' } });
          }
        }, 2000);
      }
    }
  });

   const [getAllTeachingMaterialForAdmin ] = useLazyQuery(VIEW_ALL_MATERIAL_ADMIN, {
      fetchPolicy: FETCH_POLICY,
          onCompleted: (data) => {
          },
          onError: (err) => {
              error(err?.message);
              console.error(err?.message)
          }
      }) 

      const [getAllImageMaterialAdmin] = useLazyQuery(VIEW_ALL_LIBRARY_IMAGES_ADMIN, {
              fetchPolicy: FETCH_POLICY,
              onCompleted: (data) => {
              },
              onError: (err) => {
                  error(err?.message);
                  console.error(err?.message)
              }
          });

      const [getAllPodcastAdmin] = useLazyQuery(
        VIEW_ALL_LIBRARY_PODCAST_ADMIN,
        {
          fetchPolicy: FETCH_POLICY,
          onCompleted: (data) => {},
          onError: (err) => {
            error(err?.message);
            console.error(err?.message);
          },
        }
      );

      const [getAllSyndicatedVideosAdmin, { loading: AdminLoading }] =
        useLazyQuery(GET_ALL_SYNDICATED_VIDEOS_ADMIN, {
          fetchPolicy: FETCH_POLICY,
          onCompleted: (data) => {},
          onError: (err) => {
            error(err?.message);
            console.error(err?.message);
          },
        });


  //API to check the unique name in e-books
  const [checkUniqueNameExistInWorkshop] = useLazyQuery(CHECK_UNIQUE_NAME_EXIST_IN_WORKSHOP, {
    fetchPolicy: FETCH_POLICY,
    onCompleted: (data) => { },
    onError: (err) => {
      error(err?.message);
      console.log("error mesage", err?.message);
    }
  });

  const [checkUniqueNameInAssignment] = useLazyQuery(GET_ASSIGNMENTS, {
    fetchPolicy: FETCH_POLICY,
    onCompleted: (data) => {},
    onError: (err) => {
        error(err?.message);
        if (err?.message === SUBJECT_NOT_FOUND__FOR_TEACHER_ERROR || err?.message === SUBJECT_NOT_FOUND_ERROR) {
            setTimeout(() => {
                if (role === STUDENT_ROLE) {
                    navigate('/student-classroom/assignments');
                } else {
                    navigate('/teacher-classroom/assignments');
                }
            }, 2000);
        }
    }
});

const [checkUniqueNameInSubmitAssignment] = useLazyQuery(GET_ALL_SUBMITTED_ASSIGNMENTS, {
  fetchPolicy: FETCH_POLICY,
  onCompleted: (data) => {},
  onError: (err) => {
      error(err?.message);
      if (err?.message === SUBJECT_NOT_FOUND__FOR_TEACHER_ERROR || err?.message === SUBJECT_NOT_FOUND_ERROR) {
          setTimeout(() => {
              if (role === STUDENT_ROLE) {
                  navigate('/student-classroom/assignments');
              } else {
                  navigate('/teacher-classroom/assignments');
              }
          }, 2000);
      }
  }
});

  const [getAllSyndicatedVideos] = useLazyQuery(GET_ALL_SYNDICATED_VIDEOS, {
    fetchPolicy: FETCH_POLICY,
    onCompleted: (data) => {},
    onError: (err) => {
        error(err?.message);
        if (err?.message === SUBJECT_NOT_FOUND__FOR_TEACHER_ERROR || err?.message === SUBJECT_NOT_FOUND_ERROR) {
            setTimeout(() => {
                if (role === STUDENT_ROLE) {
                    navigate('/student-classroom/videos', { state: { title: MYLIBRARY_TEXTS?.SYNDICATED_VIDEOS_TEXT } });
                } else {
                    navigate('/teacher-classroom/videos', { state: { title: MYLIBRARY_TEXTS?.SYNDICATED_VIDEOS_TEXT } });
                }
            }, 2000);
        }
    }
});

//To get video category
const [getCategory,{loading:getCategoryLoading}] = useLazyQuery(GET_CATEGORY,{
  fetchPolicy: FETCH_POLICY,
  onCompleted:(data)=>{
    const fetchedCategories = data.allSubjectCategories.nodes.map((videoData: any) => ({
      label: videoData.scNameCapitalized,
      id: videoData.scId
    }));
    setCategories(fetchedCategories);
  },
  onError:(err)=>{
     error(err?.message);
  }
});

 const [getOrCreateBulkUploadCategory] = useMutation(GET_OR_CREATE_BULKUPLOAD_CATEGORY, {
  fetchPolicy: FETCH_POLICY,
  onCompleted: (data) => {
    console.log("data from get or create category", data);
  },
  onError:(err) => {
      error(err?.message);
   }
 });

 //To add video category
 const [addCategory,{loading:addCategoryLoading}] = useMutation(ADD_CATEGORY,{
  fetchPolicy: FETCH_POLICY,
  onCompleted:(data) => {
    if(data?.addSubjectCategory){
      setVideoCategoryValue((prevValue) => {
        if (prevValue) {
          return {
            ...prevValue,
            id: data.addSubjectCategory,
            label: prevValue.label // Keep existing label or modify as needed
          };
        } else {
          return {
            id: data.addSubjectCategory,
            label: '' // Default label if prevValue is null or undefined
          };
        }
      });
      getCategory({
        variables:{
          sjId:selectedSubjectId
        }
      });
    }
  },
   onError:(err)=>{
      error(err?.message);
   }
 });

useEffect(()=>{
if(name === MYLIBRARY_TEXTS?.SYNDICATED_VIDEOS_TEXT){
  getCategory({
    variables:{
      sjId:selectedSubjectId
    }
  });
}
},[name,open]);

  const sxStyles = {
    '.MuiOutlinedInput-root': {
      paddingRight: "45px !important",
      fontWeight: 500,
      fontFamily: INTER_FONT_FAMILY,
      fontSize: FONT_SIZE_XS,
      backgroundColor: 'var(--color-whitesmoke-400)',
      borderRadius: 'var(--br-3xs)',
      height: 40,
      flexDirection: 'row',
      alignItems: 'center',
      width: '100%'
    },
    '.MuiAutocomplete-hasPopupIcon .MuiOutlinedInput-root, .MuiAutocomplete-hasClearIcon .MuiOutlinedInput-root': {
      paddingRight: 0,  // Set padding-right to 0 for specified classes
    },
    '.MuiAutocomplete-hasPopupIcon .MuiAutocomplete-inputRoot, .MuiAutocomplete-hasClearIcon .MuiAutocomplete-inputRoot': {
      paddingRight: 0,  // Set padding-right to 0 for specified classes
    },
    '.MuiOutlinedInput-notchedOutline': {
      border: 'none',
    },
    '.MuiFormLabel-root': {
      fontWeight: 500,
      fontFamily: INTER_FONT_FAMILY,
      fontSize: FONT_SIZE_XS,
      display: 'none'
    },
    '.MuiInputLabel-root': {
      fontWeight: 500,
      fontFamily: INTER_FONT_FAMILY,
      fontSize: FONT_SIZE_XS,
      display: 'none'
    },
    width: '100%',
    Padding: '0px',
    ".MuiAutocomplete-popupIndicator": {
      display: "none",
    },
  };
 // select the cover image
 const { getRootProps: coverImageRootProps, getInputProps: coverImageInputProps } = useDropzone({
  accept: {
    'image/jpeg': [],
    'image/png': [],
    'image/svg+xml': [],
    'image/jpg': []
  },
  noDrag: true, // Disable drag-and-drop
  multiple: false,
  onDrop: (acceptedFiles) => {
    if(acceptedFiles?.length !== 0){
      const maxAllowedSize = 5 * 1024 * 1024;
      if(acceptedFiles[0].size <= maxAllowedSize){
            setCoverFileName(acceptedFiles[0]?.name.replace(/\s+|\(|\)/g, ''));
            setCoverImageFile(acceptedFiles[0]);
      }else {
        error("File size must be less than or equal to 5 MB");
      }
    }
  },
  onDropRejected(fileRejections, event) {
    if (fileRejections?.[0]?.errors?.[0]?.code === 'file-invalid-type') {
      error(`Please select either jpg, jpeg, png or svg image`);
    }
  },
});

  // Drag and drop the image
  const { getRootProps, getInputProps } = useDropzone({
    accept: { ...accepted },
    multiple: true,
    onDrop: (acceptedFiles) => {
      console.log("acceptedFiles are", acceptedFiles);
      if (acceptedFiles?.length !== 0) {

        
         let filteredFiles = [...acceptedFiles];

          const duplicatesInDrop: any = [];
          const seen = new Set();

          filteredFiles.forEach((file) => {
            const key = `${file.name}-${file.size}-${file.lastModified}`;
            if (seen.has(key)) {
              duplicatesInDrop.push(file.name);
            } else {
              seen.add(key);
            }
          });

          // Remove duplicates found in this drop
          filteredFiles = filteredFiles.filter((file) => {
            const key = `${file.name}-${file.size}-${file.lastModified}`;
            return seen.has(key);
          });

          // Toast for within-drop duplicates
          if (duplicatesInDrop.length > 0) {
            error(`Duplicate file(s) are skipped`);
          }

          const existingNames = new Set(selectedFilesData.map((f) => f.file.name));

          const duplicatesWithExisting = filteredFiles.filter((file) =>
            existingNames.has(file.name)
          );

          if (duplicatesWithExisting.length > 0) {
            error(`Duplicate file(s) are skipped`);
          }

          // Remove duplicates with existing selected list
          filteredFiles = filteredFiles.filter((file) => !existingNames.has(file.name));

          // Stop if nothing left
          if (filteredFiles.length === 0) {
            return;
          }

          console.log("[filtered] filteredFiles after duplicate removal", filteredFiles);

          const totalFilesCount = selectedFilesData.length + filteredFiles.length;
            if (totalFilesCount > 10) {
              error("You can upload maximum 10 files only.");
              return;
            }

            // Total size bucket check first
            const existingTotalSize = selectedFilesData.reduce((sum, f) => sum + f.file.size, 0);
            const incomingTotalSize = filteredFiles.reduce((sum, f) => sum + f.size, 0);
            const finalTotalSize = existingTotalSize + incomingTotalSize;

            const maxAllowedBatchSize = getMaxBatchSize(type);

            if (finalTotalSize > maxAllowedBatchSize) {
              error(
                `Total upload size exceeds allowed limit of ${
                  Math.round(maxAllowedBatchSize / (1024 * 1024))
                } MB`
              );
              return;
            }

            const newFiles = Array.from(filteredFiles).filter((file) => {
              // Check file name validity first
              const fileNameWithoutExtension = file.name.substring(0, file.name.lastIndexOf('.')) || file.name;
              if (selectedFilesData && (selectedFilesData?.length > 0)) {

                if (!patterns.fileNameLengthRegex.test(fileNameWithoutExtension)) {
                  error(messages.fileNameLength);
                  return false;
                }

                if (!patterns.fileNameRegex.test(fileNameWithoutExtension)) {
                  error(messages.inBulkUploadfileName);
                  return false;
                }
          
                if (patterns.consecutiveSpecialCharsRegex.test(fileNameWithoutExtension)) {
                  error(messages.consecutiveSpecialChars);
                  return false;
                }
          
                if (!patterns.filenameAtleast1Alpha.test(fileNameWithoutExtension)) {
                  error(messages.filenameAtlease1Alpha);
                  return false;
                }
              }
        
              let maxAllowedSize = 0;
              if(type === 'profile' || type === 'image'){
                maxAllowedSize = 5 * 1024 * 1024; // 5MB
              }else if(type === 'pdf' || type === 'questionsBank' || type === "assignment" || type === "teachingMaterials"){
                maxAllowedSize = 25 * 1024 * 1024; // 25MB
              }else if(type === 'audio'){
                maxAllowedSize = 100 * 1024 * 1024; // 100MB
              }else if(type === 'video'){
                maxAllowedSize = 500 * 1024 * 1024; // 500MB
              }
        
              if (file.size > maxAllowedSize) {
                error(
                  `${file.name} exceeds the max allowed size of ${
                    maxAllowedSize / (1024 * 1024)
                  } MB`
                );
                return false;
              }
        
              return true;
            });

        if(newFiles.length === 1){
          console.log("newFiles[0]", newFiles[0]);
          setFileNameError('');
          const fileNameWithoutExtension = newFiles?.[0]?.name.split('.').slice(0, -1).join('.');
          setFileName(fileNameWithoutExtension);
        }
        const mappedFiles = newFiles.map((f) => {
          const fileNameWithoutExtension = f.name.split('.').slice(0, -1).join('.') || f.name;
          console.log("fileType", f.type);
          const fileType = getFileType(f.type);
          console.log("mapped fileType", fileType);

          let preview = '';
          const selectedFileType = f.type.split('/')?.[0];

          if (selectedFileType === 'audio') {
            preview = podcast;
          } else if (f.type === 'application/pdf') {
            preview = pdfImg;
          } else if (
            selectedFileType === 'text' ||
            f.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||
            f.type === 'application/vnd.ms-excel' ||
            f.type === 'application/vnd.ms-powerpoint' ||
            f.type === 'application/vnd.openxmlformats-officedocument.presentationml.presentation'
          ) {
            preview = selectedFileType === 'text'
              ? csvImg
              : (f.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||
                f.type === 'application/vnd.ms-excel')
                ? excelPreview
                : powerpoint;
          } else if (
            f.type === 'application/msword' ||
            f.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
          ) {
            preview = docsImg;
          } else if (f.type === 'application/epub+zip') {
            preview = epub;
          } else {
            try {
              preview = URL.createObjectURL(f);
            } catch (e) {
              preview = '';
            }
          }

          return {
            file: f,
            fileName: fileNameWithoutExtension,
            uploadFileName: fileNameWithoutExtension,
            progress: 0,
            fileType,
            filePreview: preview,
          };
        });
        setSelectedFilesData((prev) => [...prev, ...mappedFiles]);
        }
      },
    onDropRejected(fileRejections, event) {
        console.log("fileRejections are", fileRejections);
      if (type === 'profile' || type === "image") {
        if (fileRejections?.[0]?.errors?.[0]?.code === 'file-invalid-type') {
          error(`Please select either jpg, jpeg, png or svg image`);
        }
      } else if(type === 'video'){
        console.log("fileRejections", fileRejections, type);
           error('Please select MP4 file')
      } else if(type === 'questionsBank'){
          error('Please select CSV file')
      }else if(type === 'assignment'){
           error('Please select pdf, csv, ppt or word file')
      }else if(type === 'teachingMaterials'){
            error('Please select pdf, csv, ppt, epub or word file')
      }else {
        error(`Please select ${type} file`);
      }
    },
  });

  useEffect(() => {
    // set accepted file formats
    if (type === "all") {
      setAccepted({
        "video/*": [],
        'image/jpeg': [],
        'image/png': [],
        'image/svg+xml': [],
        'image/jpg': [],
        "audio/mpeg": [],
        "audio/x-wav": [],
        "audio/ogg": [],
        "application/pdf": []
      });
    } else if (type === "image" || type === "profile") {
      setAccepted({
        'image/jpeg': [],
        'image/png': [],
        'image/svg+xml': [],
        'image/jpg': []
      });
    } else if (type === "pdf" ) {
      setAccepted({ "application/pdf": [] });
    } else if (type === "video") {
      setAccepted({ "video/mp4": [] });
    } else if(type === 'audio') {
      setAccepted({ 
        "audio/mpeg": [],
        "audio/wav": [],
        "audio/ogg": [],
      });
    } else if(type === 'questionsBank'){
      isPlatform('android') ? 
      setAccepted({
      }) : 
      setAccepted({
        "text/csv": []
      }) 
    }
    else if (type === "assignment") {
      setAccepted({
        "text/csv": [],
        "application/pdf": [],
        "application/msword": [],
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document": [],
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [],
        "application/vnd.ms-excel": [],
        "application/vnd.ms-powerpoint": [],
        "application/vnd.openxmlformats-officedocument.presentationml.presentation": []
      })
    }
    else if (type === "teachingMaterials") {
      setAccepted({
        "text/csv": [],
        "application/pdf": [],
        "application/msword": [],
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document": [],
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [],
        "application/vnd.ms-excel": [],
        "application/vnd.ms-powerpoint": [],
        "application/vnd.openxmlformats-officedocument.presentationml.presentation": [],
        "application/epub+zip": []
      })
    }
  }, [type]);

  //Upload the cover image
  const handleUploadCoverImage = async () => {
    if(coverFileName && coverImageFile){
      try{
        const newFileName = `${CLASSROOM_S3_PATH}${folderName}/${moment().unix()}-${coverImageFile?.name}`;
        const { data } = await getPreSignedUrl({
          variables: {
            input: {
              key: newFileName
            }
          }
        });
        const { preSignedUrl } = data.getUploadPresignedUrl;
        await axios.put(preSignedUrl, coverImageFile, {
          headers: {
            "Content-Type": coverImageFile.type
          }
        });
  
        const fileUrl = preSignedUrl.split('?')[0];
        const url = fileUrl.split(`https://${bucketname}.s3.${region}.amazonaws.com/`)[1];
        if(setCoverImageUrl){
          setCoverImageUrl(url);
        }
      }catch(err:any){
          console.log("error while uploading cover image", err?.message);
      }
    }
  }

    //To validate file name
  const validateFileName = (value: string, field: string) => {
    if (!value || value === "") {
      return field === "AuthorName" ? "Author Name is required":"File title is required";
    }
    if (!patterns.quizNameLengthRegex.test(value) && type === "assignment") {
      return messages.quizNameLength;
    }
    if (!patterns.fileNameLengthRegex.test(value)) {
      return field === "AuthorName" ? messages.authorNameLength : messages.fileNameLength;
    }
    if (!patterns.fileNameRegex.test(value)) {
      return field === "AuthorName" ? messages.authorName : messages.fileName;
    }
    if (patterns.consecutiveSpecialCharsRegex.test(value)) {
      return field === "AuthorName" ? messages.authorNameConsecutiveSpecialChars : messages.consecutiveSpecialChars;
    }
    if (!patterns.filenameAtleast1Alpha.test(value)) {
      return field === "AuthorName" ? messages.authorNameAtlease1Alpha : messages.filenameAtlease1Alpha;
    }
    return null;
  };

  //To validate description 
  const validateDescription = (value: string) => {
    if (!value || value === "") {
      return "Description is required";
    }
    if (!patterns.descriptionLengthRegex.test(value)) {
      return messages.descriptionLength;
    }
    return null;
  }

  //To validate video category 
  const validateVideoCategory = (value: string|null|undefined) => {
    if (!value || value === "") {
      return VIDEO_CATEGORY_REQUIRED_TEXT;
    }
    if (value.length < 1 || value.length > 100) {
      return 'Video category must be between 1 and 100 characters long'
    } else {
      if (!patterns.alphabetAndNumber.test(value)) {
        return messages.VideoCategory;
      }
      if (!patterns.NotStartWithNumber.test(value)) {
        return messages.VideoCategoryNotStartNumber;
      }
    }
    return null;
  }

  // Handle file name change and clear error
  const handleFileNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setFileName(value);
    if(setUploadFileName){
      setUploadFileName(value);
    }
    setFileNameError('');
    if(hasSubmitted){
      const validationError = validateFileName(value,"FileName");
      setFileNameError(validationError);
    }
  };

    // Handle author name change and clear error
    const handleAuthorNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      const value = e.target.value;
      setAuthorNameValue(value);
      setAuthorNameError('');
      if(hasSubmitted){
        const validationError = validateFileName(value,"AuthorName");
        setAuthorNameError(validationError);
      }
    };  
    
  //To handle the description change and clear error
  const handleDescriptionChange  = (e: ChangeEvent<HTMLTextAreaElement>) => {
    const value = e.target.value;
    setDescriptionValue(value);
    setDescriptionError('');
    if(hasSubmitted){
      const validationError: any = validateDescription(value.trim());
      setDescriptionError(validationError);
    }
  }

const getDefaultValues = async () => {
  try {
    const response = await getOrCreateBulkUploadCategory({
      variables: {
        subjectId: selectedSubjectId,
      }
    });
    
    if(response){
      const catId = response?.data?.getOrCreateBulkUploadCategory?.scId;
      if (catId) {
        setBulkCategoryId(catId);
      }
    }
    console.log("Bulk category id resolved:", response);
  } catch (err: any) {
    console.log("error in get or create category", err?.message);
  }
};

  // Build mutation input for a file entry (clean version)
const buildFilePayload = (bf: BulkFileState, stableFileName: string) => {
  const filesCount = selectedFilesData?.length;
  const filenameWithoutExtension = filesCount === 1 ? stableFileName : bf.uploadFileName;
  const filepath = bf.s3Key || "";
  
  return {
    filename: filenameWithoutExtension,
    filepath,
    filesize: bf.file.size,
    // isClassroom: isShareMaterial,

    ...((page === "Teacher Teaching Material" ||
        name === MYLIBRARY_TEXTS?.EXAMINATION_GUIDE_TEXT) && {
      filetype: getFileType(bf.file.type),
    }),

    // Bulk mode defaults ( > 1 file )
    ...(selectedFilesData.length > 1
      ? {
          ...(((page === MYLIBRARY_TEXTS?.PODCAST_TEXT) || (page == "Workshop"))  && {fileDescription: `Multiple File Upload by ${profile?.getCurrentUser?.nodes?.[0]?.schoolAdminsByUId?.nodes?.[0]?.saName ? profile?.getCurrentUser?.nodes?.[0]?.schoolAdminsByUId?.nodes?.[0]?.saName : profile?.getCurrentUser?.nodes?.[0]?.uFullName ? profile?.getCurrentUser?.nodes?.[0]?.uFullName : role}`}),
          ...(page === MYLIBRARY_TEXTS?.SYNDICATED_VIDEOS_TEXT && {category_id: bulkCategoryId}), // Bulk Upload category (Animation - Angular) 6e8dde28-deac-47a0-90d4-7d060885ff15
          ...(name === MYLIBRARY_TEXTS?.EXAMINATION_GUIDE_TEXT && {authorName: `Multiple File Upload by ${profile?.getCurrentUser?.nodes?.[0]?.schoolAdminsByUId?.nodes?.[0]?.saName ? profile?.getCurrentUser?.nodes?.[0]?.schoolAdminsByUId?.nodes?.[0]?.saName : profile?.getCurrentUser?.nodes?.[0]?.uFullName ? profile?.getCurrentUser?.nodes?.[0]?.uFullName : role}`}),
        }
      : {
          ...(descriptionValue && {
            fileDescription: descriptionValue,
          }),

          ...(videoCategoryValue?.id?.trim() && {
            category_id: videoCategoryValue.id.trim(),
          }),

          ...((name === MYLIBRARY_TEXTS?.EXAMINATION_GUIDE_TEXT) && {
            authorName: authorNameValue.trim(),
          }),
        })
  };
};


  // Uploding the submitted file
  const handleSubmit = async () => {

    setHasSubmitted(true);
    if (selectedFilesData?.length === 0) {
      error("Please select the file");
      return;
    }
    
    if(selectedFilesData?.length === 1){
          if(type === 'video' && name !== MYLIBRARY_TEXTS?.SYNDICATED_VIDEOS_TEXT){
            const fileTitleError = validateFileName(fileName,'FileName');
            const descriptionValidationError = validateDescription(descriptionValue.trim());
            if(fileTitleError || descriptionValidationError){
              if(fileTitleError){
                setFileNameError(fileTitleError);
              }
              if(descriptionValidationError){
                setDescriptionError(descriptionValidationError);
              }
              return;
            }
          }

          if (type === "audio") {
            const validationError = validateFileName(fileName,"FileName");
            const descValidationError: any = validateDescription(descriptionValue.trim());
            if(validationError || descValidationError){
              if(validationError){
                setFileNameError(validationError);
              }
              if(descValidationError){
                setDescriptionError(descValidationError);
              }
              return;
            }
          }

        // Handle video category validation for "Syndicated Videos"
        if (name === MYLIBRARY_TEXTS?.SYNDICATED_VIDEOS_TEXT) {
          setVideoCategoryError('');
          if (!videoCategoryValue) {
            setVideoCategoryError(VIDEO_CATEGORY_REQUIRED_TEXT);
            return;
          }
          const categoryLabel = videoCategoryValue.inputValue || videoCategoryValue.label;
          const validationError = validateVideoCategory(categoryLabel);

          if (validationError) {
            setVideoCategoryError(validationError);
            return;
          }

          if (videoCategoryValue.id === undefined) {
            // If category ID is not yet available, add the category before proceeding
            try {
              const response = await addCategory({
                variables: { category: categoryLabel?.trim(), sjId: selectedSubjectId }
              });

              const addedCategoryId = response.data.addSubjectCategory;
              setVideoCategoryValue({ id: addedCategoryId, label: categoryLabel });
            } catch (err:any) {
              error(err?.message);
              return;
            }
          }
        }


          if (name === MYLIBRARY_TEXTS?.EXAMINATION_GUIDE_TEXT) {
            const validationError = validateFileName(fileName,"FileName");
            const authorValidationError = validateFileName(authorNameValue,"AuthorName");
            if(validationError || authorValidationError){
              if(validationError){
                setFileNameError(validationError);
              }
              if(authorValidationError){
                setAuthorNameError(authorValidationError);
              }
              return;
            }
          }

          if (type !== "profile") {
            const validationError = validateFileName(fileName,"FileName");
            if (validationError) {
              setFileNameError(validationError);
              return;
            }
          }

          //To check unique name of file
          if (name === IMAGE_MATERIAL_TEXT || (name === PODCAST_MATERIAL_TEXT)) {
            if (role === SCHOOL_ADMIN) {
              if (name === IMAGE_MATERIAL_TEXT) {
                const { data, error: SubjectNotFoundError } =
                  await getAllImageMaterialAdmin({
                    variables: {
                      subjectId: selectedSubjectId,
                      searchInput: fileName.trim(),
                      classroomIds: [selectedClassroomIdAdmin],
                    },
                  });

                if (data?.getMylibraryImagesForAdmin?.totalCount > 0) {
                  error(FILE_NAME_ALREADY_EXISTS_TEXT);
                  return;
                }
                if (SubjectNotFoundError) {
                  handleClose();
                  if (setIsUploadOpen) {
                    setIsUploadOpen(false);
                  }
                  return;
                }
              } else if (name === PODCAST_MATERIAL_TEXT) {
                const { data, error: SubjectNotFoundError } =
                  await getAllPodcastAdmin({
                    variables: {
                      subjectId: selectedSubjectId,
                      searchInput: fileName.trim(),
                      classroomIds: [selectedClassroomIdAdmin],
                    },
                  });

                if (data?.getMylibraryPodcastsForAdmin?.totalCount > 0) {
                  error(FILE_NAME_ALREADY_EXISTS_TEXT);
                  return;
                }
                if (SubjectNotFoundError) {
                  handleClose();
                  if (setIsUploadOpen) {
                    setIsUploadOpen(false);
                  }
                  return;
                }
              }
            } else {
              const { data, error: SubjectNotFoundError } =
                await getAllImagePodcastMaterial({
                  variables: {
                    lId: selectedLibraryId,
                    sjId: selectedSubjectId,
                    cId: selectedClassId,
                    limit: null,
                    offset: null,
                    searchInput: fileName.trim(),
                  },
                });

              if (data?.getMylibraryImagesPodcastsInfo?.totalCount > 0) {
                error(FILE_NAME_ALREADY_EXISTS_TEXT);
                return;
              }
              if (SubjectNotFoundError?.message === SUBJECT_NOT_FOUND__FOR_TEACHER_ERROR) {
                handleClose();
                if (setIsUploadOpen) {
                  setIsUploadOpen(false);
                }
                return;
              }
            }
          } else if (name === MATERIALS_TEXT || name === QUESTION_BANK_TEXT || name === MYLIBRARY_TEXTS?.EXAMINATION_GUIDE_TEXT) {
            if(role === SCHOOL_ADMIN){
            const { data, error: SubjectNotFoundError} = await getAllTeachingMaterialForAdmin({
              variables: {
                typeName: name,
                subjectId: selectedSubjectId,
                searchInput: fileName.trim(),
                classroomIds : [selectedClassroomIdAdmin]
              }
            });

            if (data?.getMylibraryEbooksForAdmin?.totalCount > 0) {
              error(FILE_NAME_ALREADY_EXISTS_TEXT);
              return;
            }
            if(SubjectNotFoundError){
              handleClose();
              if(setIsUploadOpen){
                setIsUploadOpen(false);
              }
              return;
            }
            }else{
            const { data, error: SubjectNotFoundError} = await getAllTeachingMaterial({
              variables: {
                lId: selectedLibraryId,
                sjId: selectedSubjectId,
                type: name,
                cId: selectedClassId,
                limit: null,
                offset: null,
                searchInput: fileName.trim(),
                orderByColumn: null,
                orderByDirection: null
              }
            });

            if (data?.getMaterialsFromEbookType?.totalCount > 0) {
              error(FILE_NAME_ALREADY_EXISTS_TEXT);
              return;
            }
            if(SubjectNotFoundError?.message === SUBJECT_NOT_FOUND__FOR_TEACHER_ERROR){
              handleClose();
              if(setIsUploadOpen){
                setIsUploadOpen(false);
              }
              return;
            }
          }
          } else if(name === MYLIBRARY_TEXTS?.SYNDICATED_VIDEOS_TEXT){
            if(role === SCHOOL_ADMIN){
            const { data, error: SubjectNotFoundError } =
              await getAllSyndicatedVideosAdmin({
                variables: {
                  subjectId: selectedSubjectId,
                  searchInput: `${fileName.trim()}`,
                  classroomIds : [selectedClassroomIdAdmin]
                },
              });

            if (data?.getSyndicatedVideosByCategoryForAdmin?.length > 0) {
              error(FILE_NAME_ALREADY_EXISTS_TEXT);
              return;
            }
            if(SubjectNotFoundError){
              handleClose();
              if(setIsUploadOpen){
                setIsUploadOpen(false);
              }
              return;
            }
            }
            else{
            const { data,error:SubjectNotFoundError } = await  getAllSyndicatedVideos({
              variables: {
                  input:{
                      cId: selectedClassId,
                      lId: selectedLibraryId,
                      sjId: selectedSubjectId,
                      searchInput: fileName.trim(),
                      category: [
                      {
                          categoryId: "",
                          limit: null,
                          offset: null
                      }
                      ]
              }
          }
          });

            if (data?.getSyndicatedVideos?.length > 0) {
              error(FILE_NAME_ALREADY_EXISTS_TEXT);
              return;
            }
            if(SubjectNotFoundError?.message === SUBJECT_NOT_FOUND__FOR_TEACHER_ERROR){
              handleClose();
              if(setIsUploadOpen){
                setIsUploadOpen(false);
              }
              return;
            }
          }
          } else if (name === "Assignment") {
            if (role === TEACHER_ROLE) {
              const { data, error: SubjectNotFoundError } = await checkUniqueNameInAssignment({
                variables: {
                  input: {
                    cId: selectedClassId,
                    sjId: selectedSubjectId,
                    searchInput: fileName.trim(),
                    limit: null,
                    offset: null
                  }
                }
              });
              if (data?.getAllUploadedAssignments?.totalCount > 0) {
                error(FILE_NAME_ALREADY_EXISTS_TEXT);
                return;
              }
              if (SubjectNotFoundError?.message === SUBJECT_NOT_FOUND__FOR_TEACHER_ERROR) {
                handleClose();
                if (setIsUploadOpen) {
                  setIsUploadOpen(false);
                }
                return;
              }
            } else if (role === STUDENT_ROLE) {
              const { data, error: SubjectNotFoundError } = await checkUniqueNameInSubmitAssignment({
                variables: {
                  input: {
                    cId: selectedClassId,
                    sjId: selectedSubjectId,
                    searchInput: fileName.trim(),
                    limit: null,
                    offset: null
                  }
                }
              });
              if (data?.getSubmittedAssignments?.totalCount > 0) {
                error(FILE_NAME_ALREADY_EXISTS_TEXT);
                return;
              }
              if (SubjectNotFoundError?.message === SUBJECT_NOT_FOUND__FOR_TEACHER_ERROR) {
                handleClose();
                if (setIsUploadOpen) {
                  setIsUploadOpen(false);
                }
                return;
              }
            }
          }else if(name === 'workshopVideo'){
            const {data} = await checkUniqueNameExistInWorkshop({
              variables: {
                searchInput: fileName.trim()
              }
            });
            if(data?.allWorkshopSessions?.nodes?.length > 0){
              error(FILE_NAME_ALREADY_EXISTS_TEXT);
              return;
            }
          }

          // Update stored state
          setSelectedFilesData(prev =>
            prev.map(file =>
              ({
                ...file,
                fileName: fileName,
                uploadFileName: fileName
              })
            )
          );
    }

    if(setPodcastDescription){
      setPodcastDescription(descriptionValue);
    }
    if(setWorkshopDescription){
      setWorkshopDescription(descriptionValue);
    }

    handleClose();

    console.log("[cover]", coverFileName, coverImageFile);
      if(selectedFilesData?.length === 1 && coverFileName && coverImageFile){
        await handleUploadCoverImage();
      }
    
    try {
      console.log("file and filename", file, fileName);

      if(setuploaded) {
        setuploaded(true);
      }

      if (setFilename) {
        setFilename(fileName);
      }
      if(setGuideAuthorName){
        setGuideAuthorName(authorNameValue);
      }
      if(setVideoCategoryData){
        setVideoCategoryData(videoCategoryValue);
      }
      if (type === "profile" && setuploaded) {
        setuploaded(false);
      }

      console.log("selecedFiles are", selectedFilesData);
      // Prepare upload promises (parallel)
      const uploadPromises = selectedFilesData.map((bf, index) => {
        return (async () => {
          try {
            console.log("uploading file:", bf);
            const cleaned = bf.uploadFileName.replace(/[^a-zA-Z0-9._\-\s]/g, "");
            const sanitizedFileName = cleaned.replace(/ /g, "_");

            const lastDotIndex = bf.file.name.lastIndexOf('.');
            const extension = lastDotIndex !== -1 ? bf.file.name.slice(lastDotIndex) : '';
            // const extension = bf.file.name.slice(bf.file.name.lastIndexOf("."));
            const newFileName = `${CLASSROOM_S3_PATH}${folderName}/${sanitizedFileName}-${moment().unix()}${extension}`;

            // 1. presigned URL
            const { data } = await getPreSignedUrl({
              variables: { input: { key: newFileName } },
            });
            const { preSignedUrl } = data.getUploadPresignedUrl;

            // 2. upload with per-file progress
            await axios.put(preSignedUrl, bf.file, {
              headers: { "Content-Type": bf.file.type },
              onUploadProgress: (progressEvent: any) => {
                if (progressEvent && progressEvent.loaded && progressEvent.total) {
                  const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                  setSelectedFilesData((prev) => {
                    const updated = prev.map((p) =>
                      p.uploadFileName === bf.uploadFileName
                        ? { ...p, progress: percentCompleted }
                        : p
                    );
                    // 🧠 compute total progress cleanly
                    const total = updated.reduce(
                      (acc, f) => acc + (f.progress ?? 0),
                      0
                    );
                    const avg = Math.round(total / updated.length);
                    setTotalProgressValue(avg);

                    return updated;
                  });
                  if(selectedFilesData?.length === 1){
                    console.log("percentCompleted single file", percentCompleted);  
                    if(setUploadProgress){
                      if(percentCompleted === 100){
                        setUploadProgress(99);
                      }else{
                      setUploadProgress(percentCompleted);
                      }
                    }
                  }
                }
              },
            });

            // success - compute s3 key
            const s3Key = preSignedUrl.split("?")[0].split(`https://${bucketname}.s3.${region}.amazonaws.com/`)[1];
            // mark file success and s3Key
            setSelectedFilesData((prev) => prev.map((p) => (p.file.name === bf.file.name ? { ...p, success: true, s3Key, progress: 100 } : p)));
            setSuccessCountValue((c) => c + 1);
            return { ok: true, bfName: bf.uploadFileName, s3Key };
          } catch (err: any) {
            setSelectedFilesData((prev) => prev.map((p) => (p.file.name === bf.file.name ? { ...p, success: false, errorMessage: err?.message || "Upload failed" } : p)));
            setFailureCountValue((c) => c + 1);
            return { ok: false, bfName: bf.uploadFileName, error: err };
          }
        })();
      });

      // Run all promises in parallel and wait for settlement
      const settled = await Promise.allSettled(uploadPromises);

      // Wait one tick so React can flush setState updates
      await new Promise(r => setTimeout(r, 0));

    } catch (err) {
      
      if(setuploaded){
        setuploaded(true);
      }
      if(setUploadFailed){
         setUploadFailed(true);
      }
      if(setUploadProgress){
        setUploadProgress(0);
      }

      setTotalProgressValue(0);
      // error("Failed to upload the file");
    }
    if(setHasSubmittedForEdit){
        setHasSubmittedForEdit(true);
    }
    if(setIsUploadOpen){
       setIsUploadOpen(false);
    }
    
    if(page) {
    trackButtonClick(ButtonClickEvents?.UPLOAD_MATERIALS_SUBMIT, {
      description: "Submiting uploaded files",
      page : page || "Upload Page"
    })
    }
  };

  // close the upload popup
  const handleClose = () => {
    setOpen(false);
    setFile(null);
    setFilePreview("");
    setFileName("");
    setDescriptionValue("");
    setAuthorNameValue("");
    setHasSubmitted(false);
    setFileNameError(null);
    setDescriptionError(null);
    setCoverFileName("");
    setCoverImageFile(null);
    setAuthorNameError(null);
    setVideoCategoryError('');
    setInputValue('');
    setVideoCategoryValue(null);
    setCategories([]);
  };
  
  // set the text to display in upload popup according to the file type
  const handleDisplayText = (text: any) => {
    if (text === "image" || text === "profile") {
      return "Image";
    } else if (text === "video") {
      return "video";
    } else if (text === "all") {
      return "image, video or any file";
    } else if (text === "pdf") {
      return "PDF file";
    } else if (text === "assignment") {
      return "PDF/Word doc/excel/PPT";
    }else if (text === "teachingMaterials") {
      return "PDF/Word doc/excel/PPT/EPUB";
    } else if (text === "questionsBank") {
      return "CSV file";
    }
  };

  //To remove the last value in input
  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Backspace' && fileName?.length === 1) {
      setFileName('');
      if(setUploadFileName){
        setUploadFileName('');
      }
      setFileNameError("File title is required");
    }
  };

  // Add an event listener for the Enter key
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === "Enter"  && document.activeElement !== descriptionRef.current) {
        e.preventDefault(); // Prevent the default form submission
        handleSubmit();
      }
    };

    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [fileName, file, descriptionValue, authorNameValue,videoCategoryValue]); // Ensure the latest fileName and file are used
  
 const handleRemove = (index: number) => {
    setSelectedFilesData((prev) => prev.filter((_, i) => i !== index));
  };

  const showFields = (type !== 'profile') && ((selectedFilesData?.length ?? 0) <= 1);

  useEffect(() => {
    const successCountFinal = selectedFilesData.filter((f) => f.success).length;
    const failureCountFinal = selectedFilesData.filter((f) => f.success === false).length;

    if(setFilesStatusData) {
      setFilesStatusData(selectedFilesData);
    }
    if(setSuccessCount) {
      setSuccessCount(successCountFinal);
    }
    if(setFailureCount) {
      setFailureCount(failureCountFinal);
    }
    if(setTotalProgress) {
      setTotalProgress(totalProgressValue);
    }

    const allUploaded = selectedFilesData.every(
      (f) =>  f.success === true || f.errorMessage
    );

    console.log("allUploaded:", allUploaded);
    if(allUploaded && selectedFilesData.length > 0) {
      const uploadedFilesPayload = selectedFilesData
      .filter((bf) => bf.success && bf.s3Key)
      .map((bf) => buildFilePayload(bf, fileName));

    if(setUploadedPayloads) {
      setUploadedPayloads(uploadedFilesPayload);
    }
    console.log("Final uploadedFilesPayload in useEffect:", uploadedFilesPayload);
    }
  }, [selectedFilesData, successCountValue, failureCountValue, totalProgressValue]);


  useEffect(() => {
    if(selectedFilesData?.length === 1){
      const currentFile = selectedFilesData[0];
      setFileNameError('');
      setFileName(currentFile.fileName);
    }
    if(selectedFilesData?.length > 0 && !bulkCategoryId && (page === MYLIBRARY_TEXTS?.SYNDICATED_VIDEOS_TEXT)) {
      getDefaultValues();
    }
  }, [selectedFilesData]);

  return (
    <>
      {open && <Dialog
        open={open}
        PaperProps={{
          className: `uploadDialogPaper`,
          style: {
            borderRadius: "20px",
            width: getScreenDimensions()?.isMobileScreen ? "290px" : "580px",
            minHeight: '319px'
          },
        }}
      >
        <div className="uploadPopupMain">
          <div className="uploadPopup" style={{gap : ((type === 'audio') && !(descriptionError)) ? '10px' : '25px'}}>
            {selectedFilesData?.length > 1 && <div className="totalFilesCount"><span className="totalLabelStyleInside">{`Total:`}</span><span>{selectedFilesData?.length}</span></div>}
            <div className="paddiv">
              <div className={`uploadContainer ${(type === 'assignment') || (type === "teachingMaterials") ? 'assignmentContainer':''}`}>
                <div className="iconGif multiple" {...getRootProps({ onClick: (e) => e.stopPropagation() })} style={{ cursor: 'default', justifyContent: selectedFilesData?.length > 4 ? 'unset': 'center'}}>
                    {selectedFilesData && selectedFilesData?.length <= 0 && (
                        <img className="cloud1Icon" src={cloudGif} alt="cloudGif"/>
                    )}
                  {selectedFilesData && selectedFilesData?.length > 0 && (
                    selectedFilesData?.map((fileItem, index) => {
                        const url = URL.createObjectURL(fileItem?.file);
                        return (
                            <Card
                                sx={{
                                    ...(getScreenDimensions()?.isMobileScreen ? { height: "75px", padding: '0px' } : { padding: "10px", minHeight: "70px" }),
                                    position: 'relative',
                                    width: "85px",
                                    margin: "5px",
                                    minWidth: "80px",
                                }}
                                key={index}
                                className="preview-card"
                                >
                                <CardCover>
                                    {fileItem?.file?.type?.startsWith("video/") ? (
                                    <video autoPlay loop muted={fileItem?.file?.type?.startsWith("video/")}  key={fileItem?.filePreview}>
                                        <source src={url} />
                                    </video>
                                    ) : (
                                    <img className="previewImage" src={getFilePreview(fileItem?.file)} alt="previewImage"/>
                                    )}
                                </CardCover>
                                {selectedFilesData?.length > 1 && <button
                                    className="remove-btn"
                                    onClick={(e) => { e.stopPropagation(); handleRemove(index); }}
                                >
                                    ✖
                                </button>}
                            </Card>
                        );
                    })
                  )}
                </div>
                <div className="contentCta">
                  <label className="dragDropContainer" {...getRootProps({ onClick: (e) => e.stopPropagation() })} style={{ cursor: 'default' }}>
                    <span className="dragDropContainer1">
                      <span>{`Drag & drop `}</span>
                      <span className="videos">
                        {handleDisplayText(type)}
                      </span>
                      {/* {role === SCHOOL_ADMIN && <span>{` Cover Here`}</span>} */}
                    </span>
                  </label>
                  <label className="orBrowseFilesContainer">
                    <span>{`or `}</span>
                    <span className="browseFiles" {...getRootProps()}>
                      browse files
                    </span>
                    <span> on your computer</span>
                  </label>
                  <input data-testid="imageUpload" {...getInputProps()} />
                </div>
              </div>
              {showFields && <div className={`fieldsMainContainer`} style={{minHeight: type === 'audio' ? '164px' : (name === MYLIBRARY_TEXTS?.EXAMINATION_GUIDE_TEXT || name === MYLIBRARY_TEXTS?.SYNDICATED_VIDEOS_TEXT) ? '157px' : ''}}>
                    <input
                      id="coverImage"
                      {...coverImageInputProps()}
                      style={{display: 'none'}}
                    />
                  <label 
                    className="coverImageContainer" 
                    {...coverImageRootProps({
                      onDrop: (e) => e.stopPropagation(),
                      onDrag: (e) => e.stopPropagation() 
                    })}
                    style={{
                      display: (type !== 'audio' && name !== MYLIBRARY_TEXTS?.EXAMINATION_GUIDE_TEXT && name!== MYLIBRARY_TEXTS?.SYNDICATED_VIDEOS_TEXT) ? 'none' : 'flex',
                      padding: ((type === 'audio' || name === MYLIBRARY_TEXTS?.EXAMINATION_GUIDE_TEXT || name === MYLIBRARY_TEXTS?.SYNDICATED_VIDEOS_TEXT) && (coverFileName)) ? 0 : '21px 22px'
                    }}
                  >
                    {
                      ((type === 'audio' || name === MYLIBRARY_TEXTS?.EXAMINATION_GUIDE_TEXT || name === MYLIBRARY_TEXTS?.SYNDICATED_VIDEOS_TEXT) && (coverFileName))
                    ?
                      <>
                        <img 
                            alt="coverImage"
                            src={coverImageFile ? URL.createObjectURL(coverImageFile) : coverImageUrl ? baseUrl + coverImageUrl : ''}
                            className={(name === MYLIBRARY_TEXTS?.EXAMINATION_GUIDE_TEXT || name === MYLIBRARY_TEXTS?.SYNDICATED_VIDEOS_TEXT) ? "selectedGuideCoverImage" : "selectedCoverImage"}
                        />
                      </>
                    :
                      <>
                        <img src={CoverPlusImage} alt="plusIcon" className="plusStyle"/>
                        <div className="covertitle">Add cover</div>
                      </>
                    }
                    
                  </label>
                  <div 
                      className="inputFieldsContainer" 
                      style={{
                        width: type !== 'audio' ? '100%' : 'calc(100% - 158px)',
                        gap: (hasSubmitted && fileNameError) ? '12px' : (hasSubmitted && videoCategoryError) ?'30px':'9px'
                      }}
                  >
                    <div className="fileUploading" style={{ display: name !== MYLIBRARY_TEXTS?.SYNDICATED_VIDEOS_TEXT ? 'none' : 'flex' }}>
                      <div className="label">
                        <label className="fileTitle">Video Category</label>
                      </div>
                      <div className="inputContainer">
                        <Autocomplete
                          // freeSolo
                          options={categories.length > 0 ? categories : [{ label: 'No options', id: 'no-options' }]}
                          getOptionLabel={(option) => {
                            // Value selected with enter, right from the input
                            if (typeof option === 'string') {
                              return option;
                            }
                            // Add "xxx" option created dynamically
                            if (option.inputValue) {
                              return option.inputValue;
                            }
                            // Regular option
                            return option.label;
                          }}
                          loading={getCategoryLoading || addCategoryLoading}
                          sx={sxStyles}
                          componentsProps={{
                            popper: {
                              sx: {
                                "& .MuiAutocomplete-paper .MuiAutocomplete-listbox": {
                                  padding: 0,
                                  overflowX: "scroll",
                                },
                                "& .MuiAutocomplete-paper .MuiAutocomplete-listbox .MuiAutocomplete-option": {
                                  whiteSpace: "nowrap",
                                  minWidth: "fit-content",
                                }
                              },
                            },
                          }}
                          filterOptions={(options, params) => {
                            const filtered = filter(options, params);
                            setVideoCategoryError('');
                            const { inputValue } = params;
                            // Suggest the creation of a new value
                            const isExisting = options.some((option) => inputValue?.toLowerCase() === option?.label?.toLowerCase());
                            if (inputValue !== '' && !isExisting) {
                              filtered.push({
                                inputValue,
                                id:'add-new',
                                label: `Add "${inputValue}"`,
                              });
                            }
                    
                            return filtered;
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              placeholder="Video Category"
                              variant="outlined"
                              onChange={()=>{setVideoCategoryError('');}}
                              onInput={()=>{setVideoCategoryError('');}}
                              InputProps={{
                                ...params.InputProps,
                                endAdornment: (
                                  <React.Fragment>
                                    {getCategoryLoading || addCategoryLoading ? <CircularProgress color="inherit" size={20} /> : null}
                                    {params.InputProps.endAdornment}
                                  </React.Fragment>
                                ),
                              }}
                            />
                          )}
                          onInputChange={(event, value) => {
                            setInputValue(value);
                            if(setVideoCategoryData){
                            setVideoCategoryData(null);
                            }
                            const validationError = validateVideoCategory(value);

                            setVideoCategoryError(validationError);
                          }}
                          onChange={async (event, newValue) => {
                            setVideoCategoryError('');
                            setVideoCategoryValue(null);
                            if (typeof newValue === 'string') {
                            }else if (newValue?.inputValue) {
                              const inputValue = newValue?.inputValue;
                              const validationError = validateVideoCategory(inputValue);
                              if (!validationError) {
                                const response = await addCategory({
                                  variables: { category: inputValue?.trim(), sjId: selectedSubjectId }
                                });
                                const addedCategoryId = response.data.addSubjectCategory;
                                setVideoCategoryError('');
                                setVideoCategoryValue({ id: addedCategoryId, label: inputValue });
                                getCategory({ variables: { sjId: selectedSubjectId } });
                              } else {
                                setVideoCategoryValue({ id: undefined, label: inputValue });
                                setVideoCategoryError(validationError);
                              }
                            } else if (!newValue) {
                              setVideoCategoryError(VIDEO_CATEGORY_REQUIRED_TEXT);
                            } else {
                              const validationError = validateVideoCategory(newValue.label);
                              if (validationError) {
                                setVideoCategoryError(validationError);
                              }
                              setVideoCategoryValue(newValue);
                            }
                          }}
                          value={videoCategoryValue || null}
                          renderOption={(props, option) => (
                            <li {...props} style={{ opacity: (categories.length < 1 && inputValue === "") ? 0.5 : 1 }}>
                              {typeof option === 'string' ? option : option.label}
                            </li>
                          )}
                          getOptionDisabled={(option) => {
                            // Disable options if there are no categories
                            if (categories.length < 1 && option?.id !== "add-new") {
                              return typeof option !== 'string'; // Disable non-string options
                            }
                            return false; // Enable all options when there are categories
                          }}                        
                          />
                        {hasSubmitted === true && videoCategoryError && <div className="errorMessage">{videoCategoryError}</div>}
                      </div>
                    </div>
                      <div 
                        className="fileUploading"
                      >
                        <div className="label">
                          <label className="fileTitle">File Title</label>
                        </div>
                        <div className="inputContainer">
                          <input
                            className="uploadedFile"
                            data-testid="uploadedFile"
                            placeholder={(type === "pdf"||type === "assignment" || type === "teachingMaterials") ? "example.pdf" : type === "image" ? "example.jpeg" : type === "audio" ? "example.mp3" : type === "questionsBank" ? "example.csv" : "example.mp4"}
                            type="text"
                            value={fileName}
                            onKeyDown={handleKeyDown}
                            onChange={handleFileNameChange}
                          />
                          {hasSubmitted === true && fileNameError && <div className="errorMessage">{fileNameError}</div>}
                        </div>
                      </div>
                      <div className="fileUploading" style={{display: descriptionAllowedTypes.includes(name ? name : '') ? 'flex' : 'none'}}>
                        <div className="label">
                          <label className="fileTitle">Description</label>
                        </div>
                        <div className="inputContainer">
                          <textarea
                            className="uploadedFileTextarea"
                            data-testid="uploadedFile-textarea"
                            placeholder={type === "pdf" ? "example.pdf" : type === "image" ? "example.jpeg" : (type === 'audio' || type === 'video') ? "Messages goes here..." : "Example.mp4"}
                            value={descriptionValue}
                            onChange={handleDescriptionChange}
                            ref={descriptionRef} // Add ref here
                          />
                          {hasSubmitted === true && descriptionError && <div className="errorMessage">{descriptionError}</div>}
                        </div>
                      </div>
                      <div className="fileUploading"style={{display: name !== MYLIBRARY_TEXTS?.EXAMINATION_GUIDE_TEXT ? 'none' : 'flex'}}>
                        <div className="label">
                          <label className="fileTitle">Author Name</label>
                        </div>
                        <div className="inputContainer">
                          <input
                            className="uploadedFile"
                            data-testid="uploadedFile"
                            placeholder="Name"
                            value={authorNameValue}
                            onChange={handleAuthorNameChange}
                          />
                          {hasSubmitted === true && authorNameError && <div className="errorMessage">{authorNameError}</div>}
                        </div>
                      </div>
                  </div>
                 
              </div>}
            
            </div>
            <div className="ctaSet" onClick={handleSubmit}>
              <button className="uploadCta">
                <label className="upload">Upload</label>
              </button>
            </div>
            <button className="icCancel" data-testid="closeButton" onClick={()=>{
              handleClose();
              if(setMaterialAction) {
                setMaterialAction('');
              }
              if(setIsUploadOpen){
                setIsUploadOpen(false);
              }
              }}>
              <img className="unionIcon" alt="closeIcon" src={closeIcon} />
            </button>
          </div>
        </div>
      </Dialog>}
    </>
  );
};

export default CommonBulkUpload;
